'use client';

import { createReactRouterBasedAdapter } from '../chunk-T5XWVJ6K.js';
import '../chunk-36UVPPVP.js';
import '../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../chunk-DASHEO2X.js';
import { useNavigate, useSearchParams } from '@remix-run/react';

var {
  enableHistorySync,
  useNuqsReactRouterBasedAdapter: useNuqsRemixAdapter,
  useOptimisticSearchParams
} = createReactRouterBasedAdapter("remix", useNavigate, useSearchParams);
var NuqsAdapter = createAdapterProvider(useNuqsRemixAdapter);
enableHistorySync();

export { NuqsAdapter, useOptimisticSearchParams };
